module.exports = __webpack_public_path__ + "media/images/multi-select-switch-b2d2e862b0f5135708c955e7ec59e6eb.png";